// @ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { surveyLink } from '../../utils/surveyLink';

export { surveyLink } from '../../utils/surveyLink';

export const familySurveys = [
	{
		title: 'Family Baseline Survey',
		description: 'Tell us how easy it is to find and understand information about your child\'s learning before Academic Eye.',
		formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSd8l34Rtk3zQ3vzM5qkFjpF6Rv-XOrh2vTzrxBge-1I4Dar4Q/viewform',
	},
	{
		title: 'Family Feedback Survey',
		description: 'Share how Academic Eye is helping you understand and support your child\'s learning.',
		formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScwEG4UbdyqGx6-ASayFSZy8JPvIoGjnaufLEfG7INIQSfsAA/viewform',
	},
];

const panelStyle = {
	background: 'var(--ae-surface)',
	borderStyle: 'solid',
	borderWidth: 1,
	borderColor: 'var(--ae-border)',
	borderRadius: 14,
	padding: 20,
	boxShadow: 'var(--ae-shadow-card)',
	minWidth: 0,
};
const panelHeadingStyle = { fontSize: 22, fontWeight: 800, color: 'var(--ae-primary-strong)', margin: '0 0 8px' };
const panelIntroStyle = { fontSize: 16, color: 'var(--ae-text-muted)', margin: '0 0 20px', lineHeight: 1.6 };
const resourceStyle = {
	background: 'var(--ae-surface)',
	border: '1px solid var(--ae-border)',
	borderRadius: 14,
	padding: 20,
	marginBottom: 24,
	boxShadow: 'var(--ae-shadow-soft)',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
	gap: 16,
};

const HelpSupport = ({ focus = null }: any) => {
	const { user } = useAuth() || {};
	const email = user?.email || '';
	const isOverview = !focus;

	return (
	<div style={{ padding: 20, maxWidth: 1000, margin: '0 auto' }}>
		{!isOverview && <Link to="/parent/help-support">Back to Family Help</Link>}
		<h1 style={{ fontSize: 30, fontWeight: 800, color: 'var(--ae-primary-strong)', marginBottom: 8 }}>
			{focus === 'tutorials' ? 'Family Tutorials' : focus === 'surveys' ? 'Family Surveys' : 'Family Help'}
		</h1>
		<p style={{ fontSize: 16, color: 'var(--ae-text-muted)', marginBottom: 32 }}>
			{focus === 'tutorials'
				? 'Videos, guides, and navigation tips to help you use Academic Eye.'
				: focus === 'surveys'
					? 'Share your experience with Academic Eye through our family surveys.'
					: 'Find guidance for using Academic Eye or share your experience with us. Choose an option below.'}
		</p>

		{isOverview && (
			<div style={{ display: 'grid', gap: 20, gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 280px), 1fr))' }}>
				<section aria-labelledby="help-overview-tutorials" style={panelStyle}>
					<h2 id="help-overview-tutorials" style={panelHeadingStyle}>Tutorials</h2>
					<p style={panelIntroStyle}>Watch the grading overview, read the family guide, and find navigation tips.</p>
					<Link to="/parent/help-support/tutorials">Open Tutorials</Link>
				</section>
				<section aria-labelledby="help-overview-surveys" style={panelStyle}>
					<h2 id="help-overview-surveys" style={panelHeadingStyle}>Surveys</h2>
					<p style={panelIntroStyle}>Complete the Family Baseline Survey or Family Feedback Survey with your account email prefilled.</p>
					<Link to="/parent/surveys">Open Surveys</Link>
				</section>
				<section aria-labelledby="help-overview-privacy" style={panelStyle}>
					<h2 id="help-overview-privacy" style={panelHeadingStyle}>Privacy</h2>
					<p style={panelIntroStyle}>How Academic Eye collects, uses, and protects student and family information (FERPA / COPPA).</p>
					<a href="/privacy">Privacy Policy</a>
				</section>
			</div>
		)}
		<div style={{ display: 'grid', gap: 28, gridTemplateColumns: 'minmax(0, 1fr)' }}>
		{focus === 'tutorials' && (
		<section id="tutorials" aria-labelledby="help-tutorials-heading" style={panelStyle}>
			<h2 id="help-tutorials-heading" style={panelHeadingStyle}>Tutorials</h2>
			<p style={panelIntroStyle}>Videos, guides, and tips for using your dashboard.</p>
				{/* Grading Overview Family Video / Academic Eye Overview Video */}
				<section style={resourceStyle}>
					<div style={{ display: 'flex', alignItems: 'center', gap: 14, minWidth: 0 }}>
						<div style={{ width: 44, height: 44, display: 'grid', placeItems: 'center', flex: '0 0 auto', borderRadius: 12, background: '#dbeafe', color: '#1d4ed8', fontSize: 22 }}>▶</div>
						<div>
							<h3 style={{ fontSize: 20, fontWeight: 800, color: 'var(--ae-primary-strong)', margin: '0 0 8px' }}>Grading Overview Family Video</h3>
							<div style={{ fontSize: 14, color: '#475569', lineHeight: 1.5 }}>
								Watch a family walkthrough of grading, student progress, and learning outcomes in Academic Eye.
							</div>
						</div>
					</div>
					<a
						href="https://canva.link/qtek6v9wzkiokc4"
						target="_blank"
						rel="noopener noreferrer"
						style={{
							background: 'linear-gradient(135deg, var(--ae-primary) 0%, #2f66c9 100%)',
							color: '#ffffff',
							borderRadius: 10,
							padding: '10px 18px',
							fontSize: 14,
							fontWeight: 700,
							textDecoration: 'none',
							maxWidth: '100%',
							boxSizing: 'border-box',
							display: 'inline-flex',
							alignItems: 'center',
							gap: 6,
							boxShadow: 'var(--ae-shadow-card)',
						}}
					>
						Watch Grading Overview Video ↗
					</a>
				</section>

				{/* Family Guide & Walkthrough Resource */}
				<section style={resourceStyle}>
					<div style={{ display: 'flex', alignItems: 'center', gap: 14, minWidth: 0 }}>
						<div style={{ width: 44, height: 44, display: 'grid', placeItems: 'center', flex: '0 0 auto', borderRadius: 12, background: '#eff6ff', color: '#2563eb', fontSize: 22 }}>📄</div>
						<div>
							<h3 style={{ fontSize: 20, fontWeight: 800, color: 'var(--ae-primary-strong)', margin: '0 0 8px' }}>Family Guide &amp; Walkthrough</h3>
							<div style={{ fontSize: 14, color: '#475569', lineHeight: 1.5 }}>
								Review a general overview of Academic Eye for families.
							</div>
						</div>
					</div>
					<a
						href="https://drive.google.com/file/d/1-wotpoNZ_BdK0_NBT8F1jsGirg9A5dj2/view?usp=drive_link"
						target="_blank"
						rel="noopener noreferrer"
						style={{
							background: 'linear-gradient(135deg, var(--ae-primary) 0%, #2f66c9 100%)',
							color: '#ffffff',
							borderRadius: 10,
							padding: '10px 18px',
							fontSize: 14,
							fontWeight: 700,
							textDecoration: 'none',
							maxWidth: '100%',
							boxSizing: 'border-box',
							display: 'inline-flex',
							alignItems: 'center',
							gap: 6,
							boxShadow: 'var(--ae-shadow-card)',
						}}
					>
						Open Family Guide ↗
					</a>
				</section>

				<section style={{ ...resourceStyle, marginBottom: 0, background: 'var(--ae-surface-soft)' }}>
					<h3 style={{ fontSize: 20, fontWeight: 800, color: 'var(--ae-primary-strong)', margin: 0 }}>Navigation Tips</h3>
					<div style={{ display: 'grid', gap: 10 }}>
						{[
							'Use Home for your dashboard overview and quick entry points.',
							'Use Grading to open Student Profiles and subject-specific progress.',
							'Use Action for action cards tied to student needs. Student Goals: Coming soon.',
							'Use Connect for teacher messages and school communication.',
							'Use Help whenever you need a walkthrough of the system.',
						].map((tip) => (
							<div key={tip} style={{ background: '#ffffff', border: '1px solid #dbe4f0', borderRadius: 12, padding: '12px 14px', color: '#334155', fontSize: 14, lineHeight: 1.5 }}>
								{tip}
							</div>
						))}
					</div>
				</section>
		</section>
		)}

		{focus === 'surveys' && (
		<section id="surveys" aria-labelledby="help-surveys-heading" style={panelStyle}>
			<h2 id="help-surveys-heading" style={panelHeadingStyle}>Surveys</h2>
			<p style={panelIntroStyle}>
				Your feedback helps us improve Academic Eye for families. Each survey opens in a new tab
				{email ? <> with your email (<strong>{email}</strong>) already filled in.</> : '.'}
			</p>
			<div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 250px), 1fr))', gap: 16 }}>
				{familySurveys.map((survey) => (
					<article key={survey.title} style={{ background: 'var(--ae-surface-soft)', border: '1px solid var(--ae-border)', borderRadius: 14, padding: 18 }}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
							<h3 style={{ fontSize: 19, fontWeight: 800, color: 'var(--ae-primary-strong)', margin: 0 }}>{survey.title}</h3>
						</div>
						<p style={{ fontSize: 14, color: '#475569', lineHeight: 1.5, margin: '0 0 14px' }}>{survey.description}</p>
						<a
							href={surveyLink(survey.formUrl, email)}
							target="_blank"
							rel="noopener noreferrer"
							aria-label={`Take the ${survey.title}`}
							style={{
								background: 'linear-gradient(135deg, var(--ae-primary) 0%, #2f66c9 100%)',
								color: '#ffffff',
								borderRadius: 10,
								padding: '10px 18px',
								fontSize: 14,
								fontWeight: 700,
								textDecoration: 'none',
								display: 'inline-flex',
								alignItems: 'center',
								gap: 6,
								boxShadow: 'var(--ae-shadow-card)',
							}}
						>
							Take Survey ↗
						</a>
					</article>
				))}
			</div>
		</section>
		)}
		</div>
	</div>
	);
};

export default HelpSupport;
